import React, { useState, useEffect } from "react";
import { CHECK_EXISTING_USER } from "../constant";
import axios from "axios";

function ConfirmPasswordNormal({
  handleInputChange,
  errors,
  isEditMode,
  defaultValue,
}) {
  const [userNameAvailable, setUserNameAvailable] = useState(null);
  const [userNameError, setUserNameError] = useState(null);
  //const isReqired = isEditMode? false : true;
  let ssss = isEditMode ? true : true;
  const isReqired = !ssss;
  const requiredClass = isEditMode ? "" : "require-field";

  const handleKeyUp = async (e) => {
    e.preventDefault();
    if (e.target.value) {
      try {
        const response = await axios.get(
          `${CHECK_EXISTING_USER}?username=${e.target.value}`
        )
        if (response?.data?.status === 400) {
            // setUserNameAvailable(true);
            setUserNameError("Username already exists");
        } else {
          // setUserNameAvailable(false);
          setUserNameError(null);
        }
      } catch (error) {
        console.error("error", error);
      }
    }
  };

  return (
    <>
      <div>
        <label className="require-field">Username</label>
        <input
          type="text"
          className="form-control"
          autoComplete="off"
          id="u_nme"
          name="u_nme"
          defaultValue={defaultValue ? defaultValue : ""}
          onChange={handleInputChange}
          placeholder=""
          onKeyUp={handleKeyUp}
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault();
            }
          }}
        />
        {userNameError && <p className="errors">{userNameError}</p>}
        {errors.u_nme && <span className="errors">{errors.u_nme}</span>}
        {/* {userNameError && <p className="errors">{userNameError}</p>}
            {errors.set_username && <span className="errors">{errors.set_username}</span>} */}
      </div>
      <div>
        <label className={requiredClass}>Password</label>
        <input
          type="password"
          className="form-control"
          autoComplete="new-password"
          name="u_pswd"
          id="u_pswd"
          required={isReqired}
          onChange={handleInputChange}
          placeholder=""
        />
        {errors.u_pswd && <span className="errors">{errors.u_pswd}</span>}
      </div>
      <div>
        <label className={requiredClass}>Confirm Password</label>
        <input
          type="password"
          className="form-control"
          autoComplete="off"
          id="c_pswd"
          name="c_pswd"
          onChange={handleInputChange}
          placeholder=""
        />
        {errors.c_pswd && <span className="errors">{errors.c_pswd}</span>}
      </div>
    </>
  );
}

export default ConfirmPasswordNormal;
